import { render, staticRenderFns } from "./PricingRules.vue?vue&type=template&id=e9706fe2"
import script from "./PricingRules.vue?vue&type=script&lang=js"
export * from "./PricingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports